<template>
  <section class="embroidery-confirm-view">
    <h5 class="embroidery-confirm-view-title text-center">{{ translations.embroideryConfirmViewStep }}</h5>
    <images-view
      :iconCheckColor="iconCheckColor"
      :itemsToPersonalize="itemsToPersonalize"
      @images-loaded="imagesLoaded"
      ref="imagesComponent">
    </images-view>

    <div class="embroidery-confirm-view-swatches">
      <span class="embroidery-confirm-view-swatches-list">
        <button
          v-for="(item, index) in colors"
          v-bind:key="index"
          class="embroidery-confirm-view-swatches-list-colors"
          :style="{ backgroundColor: item.name, color: iconCheckColor }"
          :id="`color-${ index }`"
          @click="changeFontColor(item)"
          :aria-label="item.name" 
          :aria-selected="iconCheckColor !== item.name"
        >
          <span class="icon-check"></span>
        </button>
      </span>
    </div>
  </section>
</template>

<script>
import imagesView from '@/components/Embroidery/ImagesView';

import confirmView from '@/mixins/Embroidery/ConfirmView';

export default {
  name: 'personalizationConfirmView',
  mixins: [confirmView],
  components: {
    imagesView
  },
};
</script>
